import { useQuery } from "@tanstack/react-query";
import { getBulkHistory } from "../service/bulk_ops";

interface UseBulkHistoryFilters {
  action?: string;
  action_type?: string;
  requester?: string;
  startDate?: Date;
  endDate?: Date;
}

export function useBulkHistory(filters: UseBulkHistoryFilters) {
  return useQuery({
    queryKey: ["bulk-history", filters],
    queryFn: async () => {
      const res = await getBulkHistory();
      let data = res.custom_object_records
        // remove operações sem sucesso
        .filter(
          r => r.custom_object_fields.success_count > 0
        );

      if (filters.action) {
        data = data.filter(
          r => r.custom_object_fields.action === filters.action
        );
      }

      if (filters.action_type) {
        data = data.filter(
          r => r.custom_object_fields.action_type === filters.action_type
        );
      }

      if (filters.requester) {
        data = data.filter(
          r => r.custom_object_fields.requester === filters.requester
        );
      }

      if (filters.startDate) {
        const start = new Date(filters.startDate);
        start.setHours(0, 0, 0, 0);

        data = data.filter(r => {
          const updatedAt = new Date(r.updated_at);
          return updatedAt >= start;
        });
      }

      if (filters.endDate) {
        const end = new Date(filters.endDate);
        end.setHours(23, 59, 59, 999);

        data = data.filter(r => {
          const updatedAt = new Date(r.updated_at);
          return updatedAt <= end;
        });
      }


      return data;
    },
    staleTime: 1000 * 60 * 5, // 5 minutos
  });
}
